@if (icon(); as iconName) {
  <sb-icon [size]="undefined" [name]="iconName!" />
}

<div>
  @if (title()) {
    <strong>{{ title() }}</strong>
  }

  @if (template()) {
    <ng-container *ngTemplateOutlet="template()!; context: { $implicit: message() }"></ng-container>
  } @else {
    <span>{{ message() }}</span>
  }

  @for (action of actions(); track action.id) {
    <span role="button" tabindex="0" (click)="action.callback()">
      {{ action.text }}
    </span>
  }
</div>

<button sb-icon-button [color]="'transparentInverted'" [attr.aria-label]="'Close' | translate" (click)="onClose()">
  <sb-icon [name]="'close-regular'" />
</button>
